import type GlobalDataStorageRepositoryInterface from '../interface-adapters/GlobalDataStorageRepositoryInterface';
import GlobalDataStorageRepository from '../repositories/GlobalDataStorageRepository';
import MarkedAsCanFetchGlobalDataUseCase from '../use-cases/MarkedAsCanFetchGlobalDataUseCase';
import MarkedAsFetchErrorGlobalDataUseCase from '../use-cases/MarkedAsFetchErrorGlobalDataUseCase';
import StoreGlobalDataUseCase from '../use-cases/StoreGlobalDataUseCase';

export default class GlobalDataStorageFactory {
    private static repo: GlobalDataStorageRepositoryInterface;
    private static storeGlobalDataUseCase: StoreGlobalDataUseCase;
    private static markedAsCanFetchGlobalDataUseCase: MarkedAsCanFetchGlobalDataUseCase;
    private static markedAsFetchErrorGlobalDataUseCase: MarkedAsFetchErrorGlobalDataUseCase;

    private constructor() {}

    public static makeRepo(): GlobalDataStorageRepositoryInterface {
        if (!this.repo) {
            this.repo = new GlobalDataStorageRepository();
        }

        return this.repo;
    }

    public static makeStore(): StoreGlobalDataUseCase {
        if (!this.storeGlobalDataUseCase) {
            this.storeGlobalDataUseCase = new StoreGlobalDataUseCase();
        }

        return this.storeGlobalDataUseCase;
    }

    public static makeMarkedAsCanFetchUseCase(): MarkedAsCanFetchGlobalDataUseCase {
        if (!this.markedAsCanFetchGlobalDataUseCase) {
            this.markedAsCanFetchGlobalDataUseCase = new MarkedAsCanFetchGlobalDataUseCase();
        }

        return this.markedAsCanFetchGlobalDataUseCase;
    }

    public static makeMarkedAsFetchErrorUseCase(): MarkedAsFetchErrorGlobalDataUseCase {
        if (!this.markedAsFetchErrorGlobalDataUseCase) {
            this.markedAsFetchErrorGlobalDataUseCase = new MarkedAsFetchErrorGlobalDataUseCase();
        }

        return this.markedAsFetchErrorGlobalDataUseCase;
    }
}
